import { Box, Card } from "@mui/material";
import ByzMuiTypography from "src/components/core-components/mui/inputs/ByzMuiTypography";
import ByzGrdEditButton from "src/components/core-components/mui/buttons-grid/ByzGrdEditButton";
import { useTranslate } from "src/locales";
//IDOGAN;449733;25042025
const GeneralHealthInformation = () => {
  const { t } = useTranslate();

  return (
    <Card sx={{ padding: 2, mb: 2 }}>
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "flex-start",
          gap: 3,
          pb: 1,
          borderBottom: "1px solid #E0E0E0",
          mb: 1,
        }}
      >
        <ByzMuiTypography isTitle>
          {t("patient-diet-procedures.ghi.general-health-information")}
        </ByzMuiTypography>
        <ByzGrdEditButton onClick={() => {}} />
      </Box>
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          overflowX: "auto",
          pt: 1,
          gap: 8,
        }}
      >
        <Box sx={{ display: "flex", alignItems: "center", mr: 3 }}>
          <Box
            component="img"
            src="/assets/icons/pages/nurse/hypertension.svg"
            alt="Hipertansiyon"
            sx={{ width: 20, height: 20 }}
          />
          <ByzMuiTypography marginLeft="8px">
            {t("patient-diet-procedures.ghi.hypertension")}
          </ByzMuiTypography>
        </Box>

        <Box sx={{ display: "flex", alignItems: "center", mr: 3 }}>
          <Box
            component="img"
            src="/assets/icons/pages/nurse/vegan.svg"
            alt="Vegan"
            sx={{ width: 20, height: 20 }}
          />
          <ByzMuiTypography marginLeft="8px">
            {t("patient-diet-procedures.ghi.vegan")}
          </ByzMuiTypography>
        </Box>

        <Box sx={{ display: "flex", alignItems: "center", mr: 3 }}>
          <Box
            component="img"
            src="/assets/icons/pages/nurse/diabetic.svg"
            alt="Diyabetik"
            sx={{ width: 20, height: 20 }}
          />
          <ByzMuiTypography marginLeft="8px">
            {t("patient-diet-procedures.ghi.diabetic")}
          </ByzMuiTypography>
        </Box>

        <Box sx={{ display: "flex", alignItems: "center", mr: 3 }}>
          <Box
            component="img"
            src="/assets/icons/pages/nurse/pediatric.svg"
            alt="Pediatrik"
            sx={{ width: 20, height: 20 }}
          />
          <ByzMuiTypography marginLeft="8px">
            {t("patient-diet-procedures.ghi.pediatric")}
          </ByzMuiTypography>
        </Box>

        <Box sx={{ display: "flex", alignItems: "center", mr: 3 }}>
          <Box
            component="img"
            src="/assets/icons/pages/nurse/chemotherapy.svg"
            alt="Kemoterapi"
            sx={{ width: 20, height: 20 }}
          />
          <ByzMuiTypography marginLeft="8px">
            {t("patient-diet-procedures.ghi.chemotherapy")}
          </ByzMuiTypography>
        </Box>

        <Box sx={{ display: "flex", alignItems: "center", mr: 3 }}>
          <Box
            component="img"
            src="/assets/icons/pages/nurse/geriatrics.svg"
            alt="Geriatri"
            sx={{ width: 20, height: 20 }}
          />
          <ByzMuiTypography marginLeft="8px">
            {t("patient-diet-procedures.ghi.geriatrics")}
          </ByzMuiTypography>
        </Box>

        <Box sx={{ display: "flex", alignItems: "center", mr: 3 }}>
          <Box
            component="img"
            src="/assets/icons/pages/nurse/breastfeeding.svg"
            alt="Emzirme Döneminde"
            sx={{ width: 20, height: 20 }}
          />
          <ByzMuiTypography marginLeft="8px">
            {t("patient-diet-procedures.ghi.during-breastfeeding")}
          </ByzMuiTypography>
        </Box>

        <Box sx={{ display: "flex", alignItems: "center" }}>
          <Box
            component="img"
            src="/assets/icons/pages/nurse/halal.svg"
            alt="Helal"
            sx={{ width: 20, height: 20 }}
          />
          <ByzMuiTypography marginLeft="8px">
            {t("patient-diet-procedures.ghi.halal")}
          </ByzMuiTypography>
        </Box>
      </Box>
    </Card>
  );
};

export default GeneralHealthInformation;
